import Insights from './Insights'
import ParentlessObjectives from './children/ParentlessObjectives'
import UserWithoutOKRs from './children/UserWithoutOKRs'
import LateKeyResults from './children/LateKeyResults'
import ObjectivesWithMoreThanFiveKRs from './children/ObjectivesWithMoreThanFiveKRs'
import ObjectivesWithLessThanTwoKRs from './children/ObjectivesWithLessThanTwoKRs'

export default Insights
export {
    ParentlessObjectives,
    UserWithoutOKRs,
    LateKeyResults,
    ObjectivesWithMoreThanFiveKRs,
    ObjectivesWithLessThanTwoKRs,
}
